'use client'

import * as React from 'react'

export const AffiliateTracking = () => {
  React.useEffect(() => {
    let doTheCall = true

    const affiliateTrackingLogic = async () => {
      const url = window.location.href
      if (url.includes('/ref/')) {
        //split url after /ref/
        const urlSplit = url.split('/ref/')

        //get the element after /ref/, and before the query params
        // /ref/1234?param=true => 1234
        // /ref/1234 => 1234
        // oxlint-disable-next-line unicorn/prefer-at
        const affiliateId = urlSplit[urlSplit.length - 1].split('?')[0].replace('/', '')
        if (affiliateId) {
          const captureReferral = await import('utils/affiliate-tracking').then(
            m => m.captureReferral,
          )
          if (doTheCall) {
            await captureReferral(affiliateId).catch(() => null)
          }
        }
      }
    }

    affiliateTrackingLogic()

    return () => {
      doTheCall = false
    }
  }, [])

  return null
}
